const initialState = {
    services: [],
};

export default function GetServices(state=initialState, action) {
    switch (action.type) {
        case 'REQUEST_FAIL' : {
            return { data: action.payload };
        }
        case 'APPOINTMENT_SERVICE' : {
            return Object.assign({}, state, {
                services: action.data,
            })
        }
        case 'RESPONSE_PARSE_ERROR' : {
            return { data: action.payload };
        }
        default: return state;
    }
}



// WEBPACK FOOTER //
// frontend/src/reducers/GetServices.js